module Notifications {
    export function GetNotification(parMessage: string, parType: string, delaySec: number = 10) {

        var typeIcon: string = SetIcon(parType);

        $.notify({
            icon: typeIcon,
            message: parMessage
        },
        {
            type: parType,
            newest_on_top: true,
            z_index: 9999,
            animate: {
                enter: 'animated bounceInDown',
                exit: 'animated bounceOutUp'
            },
            delay: delaySec * 1000
        });
    }

    export function GetNotificationWithProgressBar(parMessage: string, parType: string) {

        var typeIcon: string = SetIcon(parType);

        $.notify({
            icon: typeIcon,
            message: parMessage,
        },
            {
                type: parType,
                allow_dismiss: false,
                showProgressbar: true,
                newest_on_top: true,
                z_index: 9999,
                delay: 10000,
                animate: {
                    enter: 'animated bounceInDown',
                    exit: 'animated bounceOutUp'
                },
                template: `<div data-notify="container" class="col-xs-8 col-sm-3 alert alert-{0}" role="alert">
	                            <button type="button" class="close" data-notify="dismiss">×</button>
	                            <span data-notify="icon"></span>
	                            <span data-notify="title">{1}</span>
	                            <span data-notify="message">{2}</span>
	                            <div class="progress" data-notify="progressbar">
		                            <div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>
	                            </div>
	                            <a href="{3}" target="{4}" data-notify="url"></a>
                            </div>`
            });
    }

    function SetIcon(type: string) {
        if (type == "success") {
            return 'fas fa-check-circle';
        }
        else if (type == "warning") {
            return 'fas fa-exclamation-circle';
        }
        else {
            return 'fas fa-times-circle';
        }
    }
}